import React from "react";
import { Container, Title } from "../general/index";
import prodFeature from "../../assets/prod-feature.png";

const ProdFeature = () => {
  return (
    <div className="pt-5">
      <Container className="flex flex-col justify-center items-center">
        <Title className="text-center max-w-2xl" fontSize="2xl">
          Replace your new tab with a more productive workspace
        </Title>
        <img
          className="shadow-2xl"
          src={prodFeature}
          alt="Productivity hacks for working at home"
        />
      </Container>
      <div className="bg-blue w-full h-32 -mt-24 md:h-64 md:-mt-48"></div>
    </div>
  );
};

export default ProdFeature;
